import http from "../config/axiosConfig/http-common";
import ServiceBase from "./service.base";

class NotaService extends ServiceBase {

  getAll(filter) {
    //return http.get("/clientes?$top=10");
    return http.get("/notasVenda" + this.getFilter(filter));
  }

  get(id) {
    return http.get(`/notasVenda/${id}`);
  }
}

export default new NotaService();